var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-area" },
    [
      _c("swb-deal-inqry-voucher-info", {
        ref: "swb_deal_inqry_voucher_info",
        attrs: { id: _vm.id, showFlag: false }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "examine-item" }, [
        _c(
          "div",
          {
            staticClass: "examine-content",
            staticStyle: { "padding-left": "0" }
          },
          [
            _c("div", { staticClass: "form-info" }, [
              _c(
                "div",
                {
                  staticClass: "form-row",
                  staticStyle: { "line-height": "90px" }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.applyDesc,
                          expression: "applyDesc"
                        }
                      ],
                      staticClass: "width-2x",
                      attrs: { placeholder: "申请描述" },
                      domProps: { value: _vm.applyDesc },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.applyDesc = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "auto" } },
      [_c("label", { staticClass: "font-bold" }, [_vm._v("申请描述")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-063692a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-063692a8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/InqryVoucher/DealInqryVoucherApply.vue
// module id = 3272
// module chunks = 0